module.exports = __webpack_public_path__ + "static/media/Dibujo-4-Cerro-Verde.7d1f171b.jpg";